import { notification } from "antd";
import { useCallback, useState } from "react";
import { useLanguage } from "~/hooks/useLanguage";
import { changePassword } from "../services/changePassword";
import { ChangePasswordError } from "../constant/error";
import { ChangePasswordInput } from "../types/changePassword";

export const useChangePassword = () => {
  const { formatMessage } = useLanguage();
  const [loading, setLoading] = useState(false);

  const onExecute = useCallback(
    async (input: ChangePasswordInput) => {
      setLoading(true);

      try {
        const response = await changePassword(input);

        if (response.succeed) {
          notification.success({
            message: formatMessage("ChangePassword.Success.Message"),
            description: formatMessage("ChangePassword.Success.Description"),
          });
          return true;
        }
      } catch (error) {
        const changePasswordError =
          ChangePasswordError[(error as Error)?.message as string];
        if (changePasswordError) {
          notification.error({
            message: formatMessage(changePasswordError.message),
            description: changePasswordError?.description
              ? formatMessage(changePasswordError?.description)
              : undefined,
          });
        } else {
          notification.error({
            message: (error as Error)?.message,
          });
        }
        return false;
      } finally {
        setLoading(false);
      }
    },
    [formatMessage],
  );
  return {
    changePassword: onExecute,
    loading,
  };
};
